export default {
    comma: "၊",
    fullStop: ".",
    leftBracket: "(",
    rightBracket: ")",
    colon: ":"
}